import React, { createContext, useState } from "react";
const AppContext = createContext();

const AppContextProvider = ({ children }) => {
    const modalPropsObj = { refresh: false, close: false, quitAgentQueue: false, busyNotification: false }
    const menuItemsArray = [];
    const [usersCount, setUsersCount] = useState(0);
    const [quitAgentQueue, setQuitAgentQueue] = useState(false);
    const [busyNotification, setBusyNotification] = useState(false);
    const [liveAgentName, setLiveAgentName] = useState(false);
    const [modalProps, setModalProps] = useState(modalPropsObj);
    const [showHeaderFooter, setShowHeaderFooter] = useState(false);
    const [showSendBox, setShowSendBox] = useState(true);
    const [disableSendBox, setDisableSendBox] = useState(true);
    const [enableSendBoxHBT, setEnableSendBoxHBT] = useState(false);
    const [enableScroll,setEnableScroll] = useState(false);
    const [showSpinnerWheel, setShowSpinnerWheel] = useState(false);
     const [chatleftStart, setChatLeftStart] = useState(false);
     const [showSpinnerWheelOnLoad, setShowSpinnerWheelOnload] = useState(true);
    const [surveyLink, setSurveyLink] = useState("");
    const [menuOpen, setMenuOpen] = useState(false);
    const [menuItems, setMenuItems] = useState(menuItemsArray);
    const [optionSelected, setOptionSelected] = useState(false);
    const [hideStickyMenu, setHideStickyMenu ] = useState(false);
    const [showGoBackbutton, setShowGoBackbutton] = useState(true);
    const [launcherIcon, setLauncherIcon] = useState(false);
    const [webformContent, setWebformContent] = useState({});
    const [showSurvey, setShowSurvey] = useState(false);
    const [minimizeBot, setMinimizeBot] = useState(false);
    const [sendWelcomeCard, setSendWelcomeCard] = useState(true);
    const [showArticleModal, setArticleModal] = useState(false);
    const [articlePopUp, setArticlePopUp] = useState(false);
    const [pageTitleCookie, setPageTitleCookie] = useState(null);
    const [pageLanguage, setPageLanguage] = useState(null);
    const [countrySelectedOnPortal, setCountrySelectedOnPortal] = useState(null);
    const [isLiveAgent, setLiveAgent] = useState(false);
    const [overLayText,setOverLayText] = useState("");
    const [open,setOpen] = useState(false);
    const [restrictTextBox,setRestrictTextBox] = useState(false);
    const [showCaseWebFormArticleModal, setCaseWebFormArticleModal] = useState(false);
    const [moreOptionsClick, setMoreOptionsClick] = useState(false);
    const [lastTimestamp, setLastTimestamp] = useState("");
    const [isAccountChanged,setIsAccountChanged] = useState(false);
    const [transcriptTranslationRequired, setTranscriptTranslationRequired] = useState(false);
    const [liveAgentDropDownPreferred, setLiveAgentDropdownLanguagePreferred] = useState("");
    const [lastCall, setLastCall] = useState(Date.now()); // Initialize with current time
    const [botClicked, setBotClicked] = useState(false); // To track if botIconClick was invoked
    const [hasAutoTriggered, setHasAutoTriggered ] = useState(false); // To track if botIconClick was invoked,
    const [sessionId, setSessionId] = useState(null);
    const contextObj = { 
        usersCount, setUsersCount, 
        quitAgentQueue, setQuitAgentQueue,
        busyNotification, setBusyNotification, 
        surveyLink, setSurveyLink, 
        liveAgentName, setLiveAgentName, 
        modalProps, setModalProps, 
        showHeaderFooter, setShowHeaderFooter,
        showSendBox, setShowSendBox,
        disableSendBox, setDisableSendBox,
        enableSendBoxHBT, setEnableSendBoxHBT,
        enableScroll,setEnableScroll,
        showSpinnerWheel, setShowSpinnerWheel,
        menuOpen, setMenuOpen,
        menuItems, setMenuItems,
        optionSelected, setOptionSelected,
        hideStickyMenu, setHideStickyMenu,
        showGoBackbutton, setShowGoBackbutton,
        launcherIcon, setLauncherIcon,
        webformContent, setWebformContent,
        showSurvey, setShowSurvey,
        minimizeBot, setMinimizeBot,
        sendWelcomeCard, setSendWelcomeCard,
        showArticleModal, setArticleModal,
        articlePopUp, setArticlePopUp,
        pageTitleCookie, setPageTitleCookie,
        pageLanguage, setPageLanguage,
        countrySelectedOnPortal, setCountrySelectedOnPortal,
        isLiveAgent, setLiveAgent,
        overLayText,setOverLayText,
        open,setOpen,
        restrictTextBox,setRestrictTextBox,
        showCaseWebFormArticleModal,setCaseWebFormArticleModal,
        moreOptionsClick, setMoreOptionsClick,
        lastTimestamp, setLastTimestamp,
        isAccountChanged, setIsAccountChanged,
        transcriptTranslationRequired, setTranscriptTranslationRequired,
        liveAgentDropDownPreferred, setLiveAgentDropdownLanguagePreferred,
        lastCall, setLastCall,
        botClicked, setBotClicked,
        hasAutoTriggered, setHasAutoTriggered,
        showSpinnerWheelOnLoad, setShowSpinnerWheelOnload,
        chatleftStart, setChatLeftStart,
        sessionId, setSessionId

   }

    return (
        <AppContext.Provider value={contextObj}>
            {children}
        </AppContext.Provider>
    );
};

export { AppContext, AppContextProvider };